import { Box, Typography } from '@mui/material'
import { t } from '~/utils/narration'

export default function Card(props: any) {
  return (
    <Box sx={{ py: 0.5, px: 1, mb: 0.5, width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <img src={props.img} width={36} />
      <Typography variant='subtitle1' sx={{ px: 2 }}>{t(props.title)}</Typography>
    </Box>
  )
}
